import axeCore from '@axe-core/react';

export const axe = async (
  React,
  ReactDOM,
  { enabled = false, timeout = 5000, delay = 3000, ...config }
) => {
  if (enabled) {
    setTimeout(async () => {
      await axeCore(React, ReactDOM, timeout, config).catch(console.error);
    }, delay);
  }
};
